<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/SOTL_ser_pref">Series preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/SOTL_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/SOTL_abbrev">Abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/SOTL_ch01"><span class="bold2">1 Introduction</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/SOTL_ch01#sigil_toc_id_2">Preliminary issues</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/SOTL_ch02"><span class="bold2">2 Adam: the first servant</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/SOTL_ch02#sigil_toc_id_4">God creates a servant</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/SOTL_ch02#sigil_toc_id_5">The servant fails</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/SOTL_ch02#sigil_toc_id_6">God calls a servant</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/SOTL_ch02#sigil_toc_id_7">Conclusion</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch03" title="Link target outside of Sample"><span class="bold2">3 Moses: the servant prophet</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch03#sigil_toc_id_9" title="Link target outside of Sample">Setting the stage</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch03#sigil_toc_id_10" title="Link target outside of Sample">Moses as servant of Yahweh in the Torah</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch03#sigil_toc_id_11" title="Link target outside of Sample">Moses as servant of Yahweh in the Prophets and the Writings</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch03#sigil_toc_id_12" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch04" title="Link target outside of Sample"><span class="bold2">4 Joshua: the servant conqueror</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch04#sigil_toc_id_14" title="Link target outside of Sample">The transition from one servant to another</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch04#sigil_toc_id_15" title="Link target outside of Sample">Joshua does what Moses the servant commanded</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch04#sigil_toc_id_16" title="Link target outside of Sample">Yahweh performs similar acts through Joshua</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch04#sigil_toc_id_17" title="Link target outside of Sample">The death of Joshua the servant</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch04#sigil_toc_id_18" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch05" title="Link target outside of Sample"><span class="bold2">5 David: the servant king</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch05#sigil_toc_id_20" title="Link target outside of Sample">Israel’s need for a servant</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch05#sigil_toc_id_21" title="Link target outside of Sample">The life of David the servant</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch05#sigil_toc_id_22" title="Link target outside of Sample">Solomon the servant’s son</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch05#sigil_toc_id_23" title="Link target outside of Sample">The eschatological hope in David the servant</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch05#sigil_toc_id_24" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch06" title="Link target outside of Sample"><span class="bold2">6 The Isaianic servant: the suffering servant</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch06#sigil_toc_id_26" title="Link target outside of Sample">Servant references in Isaiah 1 – 39</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch06#sigil_toc_id_27" title="Link target outside of Sample">The servant in Isaiah 40 – 665</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch06#sigil_toc_id_28" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch07" title="Link target outside of Sample"><span class="bold2">7 Jesus: the servant par excellence</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch07#sigil_toc_id_30" title="Link target outside of Sample">Servant language applied to Jesus</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch07#sigil_toc_id_31" title="Link target outside of Sample">Jesus as the fulfilment of previous servants</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch07#sigil_toc_id_32" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch08" title="Link target outside of Sample"><span class="bold2">8 The apostles: servants of Christ</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_34" title="Link target outside of Sample">Paul the servant of Christ</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_35" title="Link target outside of Sample">Paul’s ministry co-workers</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_36" title="Link target outside of Sample">Peter the servant of Christ</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_37" title="Link target outside of Sample">James the servant of God and of the Lord Jesus Christ</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_38" title="Link target outside of Sample">Jude the servant of Christ</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_39" title="Link target outside of Sample">John the servant of Christ</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch08#sigil_toc_id_40" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch09" title="Link target outside of Sample"><span class="bold2">9 The church: a servant people</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch09#sigil_toc_id_42" title="Link target outside of Sample">Gospels and Acts</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch09#sigil_toc_id_43" title="Link target outside of Sample">Paul’s letters</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch09#sigil_toc_id_44" title="Link target outside of Sample">Catholic epistles</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch09#sigil_toc_id_45" title="Link target outside of Sample">Revelation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch09#sigil_toc_id_46" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_ch10" title="Link target outside of Sample"><span class="bold2">10 Conclusion</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/SOTL_ch10#sigil_toc_id_48" title="Link target outside of Sample">Implications</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/SOTL_biblio" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/SOTL_ind_aut" title="Link target outside of Sample">Search names for authors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/SOTL_ind_scrip" title="Link target outside of Sample">Search items for Scripture references</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/SOTL_ind_anc" title="Link target outside of Sample">Search items for ancient sources</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/SOTL_series" title="Link target outside of Sample">Titles in this series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/SOTL_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/UK_ata" title="Link target outside of Sample">About the author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/UK_moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SOTL_contents.vue?4187c62f